// import { ProductService } from '@/common/api.service';
// import { SELECT_ANSWER, SELECT_NEXT_QUESTION, SELECT_PREV_QUESTION, SUBMIT_QUESTIONS } from './actions.type';

import { SELECT_PRODUCT_PACK } from './actions.type';
import { SET_PRODUCTS, SET_SELECTED_PRODUCT_PACK } from './mutations.type';


const state = {
    products: [],
    selectedProduct: {}
};

const getters = {
    products(state) {
        return state.products
    },
    selectedPack(state) {
        return state.products.filter(x => x.Selected)[0];
    },
    noProductsFound(state) {
        return state.products.length === 0;
    }
}

const actions = {
    [SELECT_PRODUCT_PACK] ({ commit }, payload) {
        commit(SET_SELECTED_PRODUCT_PACK, payload)
    }
}

const mutations = {
    [SET_PRODUCTS] (state, payload) {
        state.products = payload;
    },
    [SET_SELECTED_PRODUCT_PACK] (state, payload) {
        var pack = state.products.find(x => x.Id == payload);

        pack.Selected = true;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};